module.exports = __webpack_public_path__ + "img/hotel3.dba457d4.png";